import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(params.get("role") === "owner" ? "owner" : "traveler");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const u = await register({ name, email, password, role });
      toast.success(`Bienvenue ${u.name}`);
      if (u.role === "admin") navigate("/admin");
      else if (u.role === "owner") navigate("/owner");
      else navigate("/traveler");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erreur");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="pt-24 sm:pt-28 min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="flex items-center justify-center px-6 py-16 order-2 lg:order-1">
        <form onSubmit={submit} data-testid="register-form" className="w-full max-w-md">
          <div className="text-[11px] uppercase tracking-[0.3em] text-neutral-500 font-bold mb-3">Inscription</div>
          <h1 className="font-display text-4xl font-bold tracking-tight mb-8">Rejoindre la communauté bretonne</h1>

          <div className="grid grid-cols-2 gap-2 mb-6 border border-black/15">
            <button data-testid="role-traveler" type="button" onClick={() => setRole("traveler")} className={`py-3 text-sm font-semibold ${role === "traveler" ? "bg-[#0A0A0A] text-white" : "bg-white text-neutral-700"}`}>
              Voyageur
            </button>
            <button data-testid="role-owner" type="button" onClick={() => setRole("owner")} className={`py-3 text-sm font-semibold ${role === "owner" ? "bg-[#0A0A0A] text-white" : "bg-white text-neutral-700"}`}>
              Propriétaire
            </button>
          </div>

          <label className="block mb-5">
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-neutral-500 mb-2">Nom complet</div>
            <input data-testid="reg-name" type="text" required value={name} onChange={(e) => setName(e.target.value)} className="w-full border-b-2 border-black/20 focus:border-[#0A0A0A] outline-none py-3 bg-transparent" />
          </label>
          <label className="block mb-5">
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-neutral-500 mb-2">Email</div>
            <input data-testid="reg-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border-b-2 border-black/20 focus:border-[#0A0A0A] outline-none py-3 bg-transparent" />
          </label>
          <label className="block mb-8">
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-neutral-500 mb-2">Mot de passe</div>
            <input data-testid="reg-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border-b-2 border-black/20 focus:border-[#0A0A0A] outline-none py-3 bg-transparent" />
          </label>

          <button data-testid="reg-submit" type="submit" disabled={submitting} className="w-full bg-[#0A0A0A] text-white py-4 font-semibold hover:bg-[#1B2A49] transition-colors disabled:opacity-50">
            {submitting ? "Création…" : "Créer mon compte"}
          </button>

          <p className="mt-6 text-sm text-neutral-600">
            Déjà inscrit ? <Link to="/login" className="font-semibold underline underline-offset-4">Se connecter</Link>
          </p>
        </form>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=1600" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute bottom-12 right-12 text-white max-w-md text-right">
          <div className="text-[11px] uppercase tracking-[0.3em] mb-4 text-white/80">Gwenn ha Du · Liberté</div>
          <h2 className="font-display text-4xl font-bold leading-tight">La Bretagne, vraie, sans intermédiaire.</h2>
        </div>
      </div>
    </div>
  );
}
